import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function ImgTextK() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const textFadeInOut = (el: any) => {
        const target = `.dg200 .imgTextK ${el}`;
        const targetEl = document.querySelector(target) as HTMLElement;
        const targetH = targetEl?.offsetHeight || 100;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: targetH,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: targetH,
            triggerHook: 1,
            duration: targetH,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: isMobile ? '-.44rem' : '-60px',
            triggerHook: 0,
            duration: targetH,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 0 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        if (!isMobile) {
            textFadeInOut('.title');
            textFadeInOut('.desc');
        }
    }, []);

    return (
        <div className={`imgTextK ${css.imgTextK} ${isMobile ? 'imgTextK_h5' : 'imgTextK_pc'}`}>
            <div className="box">
                <div className="left">
                    <p className="title">{t('dg200.imgTextK_title')}</p>
                    <p className="desc">{t('dg200.imgTextK_desc')}</p>
                </div>
                <div className="right">
                    <div className="imgBox">
                        <EFVideo
                            className="imgTextK-video imgTextK-video-0"
                            sources={[`/video/dg200/11_2${isMobile ? '_h5' : ''}.webm`, `/video/dg200/11_2${isMobile ? '_h5' : ''}.mp4`]}
                            width="100%"
                            height="100%"
                            aria-label={t('dg200.imgTextK_img2_desc')}
                        />
                        <p className="imgDesc">{t('dg200.imgTextK_img2_desc')}</p>
                    </div>
                    <div className="imgBox">
                        <EFVideo
                            className="imgTextK-video imgTextK-video-1"
                            sources={[`/video/dg200/11_1${isMobile ? '_h5' : ''}.webm`, `/video/dg200/11_1${isMobile ? '_h5' : ''}.mp4`]}
                            width="100%"
                            height="100%"
                            aria-label={t('dg200.imgTextK_img1_desc')}
                        />
                        <p className="imgDesc">{t('dg200.imgTextK_img1_desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
